import {
    READ_MULTISTART_FROM_FORAGE,
    RESET_MULTISTART,
    ADD_MULTISTART,
    REMOVE_MULTISTART,
    TOGGLE_MULTISTART,
} from './constants'

export function setMultistart(multistart) {
    return {
        type: READ_MULTISTART_FROM_FORAGE,
        payload: multistart,
    }
}

export function resetMultistart() {
    return { type: RESET_MULTISTART }
}

export function addUserToMultistart(serverId, userId) {
    return {
        type: ADD_MULTISTART,
        payload: { serverId, userId },
    }
}

export function removeUserFromMultistart(serverId, userId) {
    return {
        type: REMOVE_MULTISTART,
        payload: { serverId, userId },
    }
}

export function toggleMultistartForUser(serverId, userId) {
    return {
        type: TOGGLE_MULTISTART,
        payload: { serverId, userId },
    }
}



// WEBPACK FOOTER //
// ./src/features/Users/data/multiStart/actions.js